import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'


// Exam Package Directives
import { iconClassDirective } from '../exampackage/exampackage.component';
import { startClickDirective  } from '../exampackage/exampackage.component';
import { calDurationDirective } from '../exampackage/exampackage.component';
import { roundClassDirective } from '../exampackage/exampackage.component';
import { FindProctorDirective } from '../exampackage/exampackage.component';
import { reportClickDirective } from '../exampackage/exampackage.component';
import { ViewBadgeDirective } from '../exampackage/exampackage.component';
import { retakeClickDirective } from '../exampackage/exampackage.component';
import { statusValDirective } from '../exampackage/exampackage.component';
import { certificateClickDirective } from '../exampackage/exampackage.component';
import { solutionClickDirective, ExamPackageComponent } from '../exampackage/exampackage.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

//Pagination
import {NgxPaginationModule} from 'ngx-pagination';
//Range slider
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { PagerService } from '../_services/PagerService'

@NgModule({
    imports: [BrowserModule, FormsModule, HttpModule, NgxPaginationModule, IonRangeSliderModule, SlimLoadingBarModule.forRoot()],
  declarations: [FooterComponent,HeaderComponent,ExamPackageComponent,iconClassDirective, startClickDirective, calDurationDirective,
      roundClassDirective, FindProctorDirective, reportClickDirective, ViewBadgeDirective, retakeClickDirective, statusValDirective,
      certificateClickDirective, solutionClickDirective],
  exports: [ExamPackageComponent],
  providers: [PagerService],
})

export class ExamPackageModule {
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/exampackage/app.exampackagemodule.ts